










import Vue, { PropType } from 'vue';
import { Doc, genDownloadDocUrl } from '@/modules/doc';

export default Vue.extend({
  name: 'GChatFileMessageContainer',
  props: {
    senderCID: {
      type: String as PropType<string>,
    },
    doc: {
      type: Object as PropType<Doc>,
    },
  },
  data() {
    return {
      downloadUrl: '',
      isImage: false,
      formattedFileSize: '',
    };
  },
  methods: {
    async generateDownloadUrl() {
      if (!this.doc.id) return;
      try {
        const res = await genDownloadDocUrl(this.senderCID, this.doc.id);
        if (!res) return;
        this.downloadUrl = res;
      } catch (err: any) {
        console.log(err);
      }
    },
    checkIfImage() {
      const regex = RegExp(/image|png|jpg|jpeg|svg/);
      this.isImage = regex.test(this.doc.fileName);
    },
    formatFileSize() {
      if (!this.doc.fileSize) {
        this.formattedFileSize = '0 Bytes';
        return;
      }
      const k = 1000;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(this.doc.fileSize) / Math.log(k));
      if (!sizes[i]) {
        this.formattedFileSize = `${this.doc.fileSize}`;
        return;
      }
      this.formattedFileSize = `${this.doc.fileSize / k ** i} ${sizes[i]}`;
    },
    onClickDownload() {
      const a = document.createElement('a');
      a.href = this.downloadUrl;
      a.target = '_blank noopener noreferrer';
      a.setAttribute('download', this.doc.fileName);
      a.click();
    },
  },
  async mounted() {
    await this.generateDownloadUrl();
    this.checkIfImage();
    this.formatFileSize();
  },
});
